import { Component, Input, OnInit, ViewEncapsulation, ChangeDetectionStrategy, signal } from '@angular/core';
import { FormBuilder, FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import {
  NgbActiveModal,
  NgbModal,
  NgbModalOptions,
} from "@ng-bootstrap/ng-bootstrap";
import { Subject } from "rxjs";
import { AppStateService } from "../core-module/services/app-state.service";
import {environment} from "../../environments/environment";
import { DeviceConfigStateService } from "../core-module/services/state/device-config-state.service";
import { UiSignalsStateService } from "../core-module/services/state/ui-signals-state.service";

@Component({
  standalone: false,
  selector: "app-feature-file-partial-compatible-modal",
  templateUrl: "./feature-file-partial-compatible-modal.component.html",
  styleUrls: ["./feature-file-partial-compatible-modal.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class FeatureFilePartialCompatibleModalComponent implements OnInit {
  @Input() public hasSuccessfulFeatures: boolean;
  @Input() public device;
  uploadFeature;
  popup: string;
  isFeatureSelected = signal(false);
  loading = signal(false);
  featureFile;
  startConfigForm: FormGroup;
  url;
  feature12NcName: unknown[] = [];
  subscription;
  envScehmaLIstApi;
  unsubscribe = new Subject<void>();
  noCompatibleFeatures = signal(false);
  envAloschemaDetails;
  envStartConfigURL;
  startConfigurationData = {};
  constructor(
    
    public activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private fb: FormBuilder,
    public route: Router,
    private appState: AppStateService,
    private deviceConfig: DeviceConfigStateService,
    private uiSignals: UiSignalsStateService
  ) {}
  configureDevice() {
    this.activeModal.close();
    this.deviceConfig.triggerConfigureDevice.next(true);
  }
  remove() {
    // Note: This handles partial feature file compatibility, not Edit Device
    this.uiSignals.removeModes("invalid");
    this.activeModal.close();
    this.deviceConfig.closeConfigureDeviceModal.next(true);
    this.modalService.dismissAll();
  }
  ngOnInit() {
    this.startConfigForm = this.fb.group({
      selectedFeatures: this.fb.array([]),
    });
    // this.service.getEnvValue();
    // this.service.getEnvData
    //   .pipe(takeUntil(this.unsubscribe))
    //   .subscribe((url) => {
    //     this.url = url;
    //   });
    this.url = environment.multiOneAPIUrl;
    this.uiSignals.getSelectedModal.subscribe((resp) => {
      this.popup = resp;
    });
    this.uploadFeature = this.appState.getImportFeatureData();
    if (this.uploadFeature.successfulFeatures.length > 0) {
      this.noCompatibleFeatures.set(false);
    } else {
      this.noCompatibleFeatures.set(true);
    }
    this.isFeatureSelected.set(!!this.startConfigForm.value.selectedFeatures.length);
  }
}

